/* Camada interativa do clone (shiny-wipes). O prep renomeia os custom elements do Sense
   dele (slider-component -> cl-slider-component) para o main.js do Shrine nao se prender a
   copia; aqui volta o comportamento do SliderComponent do Dawn: trilho com rolagem nativa,
   setas que andam 1 slide, contador "1 / N" e setas desabilitadas nas pontas. */
(function () {
  'use strict';
  function q(el, cls) { return el.querySelector('.clx-' + cls + ', .' + cls); }

  function initSlider(root) {
    if (root.__clInit) return; root.__clInit = true;
    var slider = root.querySelector('[id^="Slider-"]') || q(root, 'slider');
    if (!slider) return;
    var prev = root.querySelector('button[name="previous"]');
    var next = root.querySelector('button[name="next"]');
    var cur = root.querySelector('.slider-counter--current');
    var tot = root.querySelector('.slider-counter--total');
    function items() {
      return Array.prototype.filter.call(slider.children, function (li) { return li.offsetWidth > 0 && li.offsetHeight > 0; });
    }
    function step() {
      var it = items(); if (it.length < 2) return slider.clientWidth || 1;
      return (it[1].offsetLeft - it[0].offsetLeft) || it[0].offsetWidth || 1;
    }
    function update() {
      var it = items(); if (!it.length) return;
      var s = step();
      var visible = Math.max(1, Math.floor((slider.clientWidth - it[0].offsetLeft + 1) / s));
      var pages = Math.max(1, it.length - visible + 1);
      var page = Math.min(pages, Math.round(slider.scrollLeft / s) + 1);
      if (cur) cur.textContent = page;
      if (tot) tot.textContent = pages;
      if (prev) { if (page <= 1) prev.setAttribute('disabled', 'disabled'); else prev.removeAttribute('disabled'); }
      if (next) { if (page >= pages) next.setAttribute('disabled', 'disabled'); else next.removeAttribute('disabled'); }
    }
    function go(dir) { slider.scrollTo({ left: slider.scrollLeft + dir * step(), behavior: 'smooth' }); }
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); go(-1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); go(1); });
    slider.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  // seletor de pais do rodape (mercados da nossa loja): abre/fecha e envia o form /localization
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[class*="localization-selector"]');
    if (btn && btn.tagName === 'BUTTON') {
      var box = btn.parentElement.querySelector('[data-cl-loc]'); if (!box) return;
      e.preventDefault();
      var open = box.hasAttribute('hidden');
      if (open) box.removeAttribute('hidden'); else box.setAttribute('hidden', '');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    var a = e.target.closest('[data-cl-loc] a[data-value]');
    if (a) {
      e.preventDefault();
      var f = a.closest('form'), inp = f && f.querySelector('input[name="country_code"]');
      if (inp) { inp.value = a.getAttribute('data-value'); f.submit(); }
      return;
    }
    document.querySelectorAll('[data-cl-loc]:not([hidden])').forEach(function (box) {
      if (!box.parentElement.contains(e.target)) {
        box.setAttribute('hidden', '');
        var b = box.parentElement.querySelector('[class*="localization-selector"]'); if (b) b.setAttribute('aria-expanded', 'false');
      }
    });
  });

  function boot() {
    document.querySelectorAll('cl-slider-component').forEach(initSlider);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
